import { useState } from "react";
import { updateGfDeal } from "../../../../api/giftingClient";
import type { GfEntry } from "../../../../types/gifting";
import { errMsg } from "../../gfUtil";
import { GfButton, GfField } from "../../ui/GfUi";

const CARRIERS = ["ヤマト運輸", "佐川急便", "日本郵便"];

/**
 * 配送業者・追跡番号の入力。
 * - 段階4（住所受領済み）: 「発送済みにする」で段階5へ（実行は親＝主ボタンと同じ処理）
 * - 段階5以降: 追跡情報の修正（updateGfDeal）
 * 入力値は親が持つ（主ボタンからも同じ値で advance できるように）。
 */
export const TRACKING_CARRIER_ID = "gf-track-carrier";

export function TrackingForm({
  entry,
  carrier,
  trackingNo,
  onCarrier,
  onTrackingNo,
  onShip,
  onSaved,
  toast,
  busy,
}: {
  entry: GfEntry;
  carrier: string;
  trackingNo: string;
  onCarrier: (v: string) => void;
  onTrackingNo: (v: string) => void;
  /** 段階4: 発送済みにする */
  onShip: () => void;
  /** 段階5以降: 保存後に再読込 */
  onSaved: () => Promise<void>;
  toast: (m: string) => void;
  busy: boolean;
}) {
  const shipping = entry.stage === 4;
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      await updateGfDeal(entry.id, { ship_carrier: carrier.trim() || null, ship_tracking_no: trackingNo.trim() || null });
      toast("追跡情報を更新しました");
      await onSaved();
    } catch (e) {
      toast(errMsg(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="gf-panel-section">
      <div className="gf-panel-section-title">{shipping ? "発送（追跡番号の入力）" : "追跡情報"}</div>
      <div className="gf-form-grid">
        <GfField label="配送業者">
          <input
            id={TRACKING_CARRIER_ID}
            className="gf-input"
            list="gf-carriers"
            value={carrier}
            onChange={(e) => onCarrier(e.target.value)}
            placeholder="ヤマト運輸"
          />
          <datalist id="gf-carriers">
            {CARRIERS.map((c) => (
              <option key={c} value={c} />
            ))}
          </datalist>
        </GfField>
        <GfField label="追跡番号">
          <input className="gf-input is-mono" value={trackingNo} onChange={(e) => onTrackingNo(e.target.value)} placeholder="4402-1187-3301" />
        </GfField>
      </div>
      {shipping ? (
        <GfButton variant="primary" disabled={busy || !carrier.trim() || !trackingNo.trim()} onClick={onShip}>
          発送済みにする
        </GfButton>
      ) : (
        <GfButton size="sm" disabled={saving} onClick={() => void save()}>
          追跡情報を更新
        </GfButton>
      )}
    </section>
  );
}
